module.exports = __webpack_public_path__ + "static/media/Tiwiter.18385b7f.svg";